import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { PIPELINES_ACTION_TYPE } from '../actions';

const initialState = {};

const pipelinesSchemaReducer = (state = initialState, { type, payload }) =>
  produce(state, () => {
    switch (type) {
      case PIPELINES_ACTION_TYPE.GET_PIPELINES_SCHEMA:
        return payload || state;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default pipelinesSchemaReducer;
